import { FC, useMemo } from "react";
import { EMPTY_STRING } from "../../../../common/constants/common.constants";
import { IMenuItem } from "../../../../common/interfaces/user-dashboard.interface";
import SkeletonItem from "../../../SkeletonItem/SkeletonItem";
import "./SidebarMenuItem.scss";
import { dashboardStore } from "../../../../contexts/dashboardStore";

const SidebarMenuItem: FC<{ menuItem: IMenuItem; isRounded?: boolean }> = ({
  menuItem,
  isRounded,
}) => {
  const { setActiveStep, activeStep, initialLoading, clubs } = dashboardStore();

  const checkIsActive = useMemo(() => {
    return menuItem.step === activeStep && isRounded
      ? "sidebar-menu-item--active sidebar-menu-item--rounded"
      : menuItem.step === activeStep
      ? "sidebar-menu-item--active"
      : isRounded
      ? "sidebar-menu-item--rounded"
      : EMPTY_STRING;
  }, [activeStep, isRounded]);

  return (
    <>
      {!initialLoading && clubs ? (
        <div
          onClick={() => setActiveStep(menuItem.step)}
          className={`${"sidebar-menu-item " + checkIsActive}`}
        >
          <menuItem.icon />
          <p>{menuItem.title}</p>
        </div>
      ) : (
        <div className="sidebar-menu-item">
          <SkeletonItem height={20} width={20} borderRadius={50} />
          <SkeletonItem height={20} width={100} borderRadius={5} />
        </div>
      )}
    </>
  );
};

export default SidebarMenuItem;
